import Vue from 'vue'
import Vuex from 'vuex'

import courtCase from './_store/court-case.module'
import judgeReestr from './_store/judge-reestr.module'
import judge from './_store/judge.module'
import event from './_store/event.module'
import fileStore from './_store/file.module'
import letter from './_store/letter.module'
import list from './_store/list.module'
import advocat from './_store/advocat.module'
import specialist from './_store/specialist.module'
import appreestr from './_store/appreestr.module'
import category from './_store/category.module'
import users from './_store/users.module'
import distribution from './_store/distribution.module'
import organization from './_store/organization.module'
import menu from './_store/menu.module'
import me from './_store/me.module'
import page from './_store/page.module'
import knowledgeBase from './_store/knowledgebase.module'
import court from './_store/court.module'
import gsu from './_store/gsu.module'
import expert from './_store/expert.module'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    route: null,

    currentCase: null,
    currentSessionIndex: null,
    isSubpoena: true,
    currentMember: null,
    inFileStore: false,
    inCalendar: false,
    inJudgeReestr: false,
    inCategory: false,
    inUsers: false,
    inDistribution: false,
    inCourt: false,
  },
  mutations: {
    setRoute(state, payload) {
      state.route = payload
    },

    setCase(state, selectedCase) {
      state.currentCase = selectedCase
    },
    setSessionIndex(state, selectedSessionIndex) {
      state.currentSessionIndex = selectedSessionIndex
    },
    setSubpoena(state, value) {
      state.isSubpoena = value
    },
    setMember(state, selectedMember) {
      state.currentMember = selectedMember
    },
    setInFileStore(state, val) {
      state.inFileStore = val
    },
    setInCalendar(state, val) {
      state.inCalendar = val
    },
    setInJudgeReestr(state, val) {
      state.inJudgeReestr = val
    },
    setInCategory(state, val) {
      state.inCategory = val
    },
    setInUsers(state, val) {
      state.inUsers = val
    },

    setInDistribution(state, val) {
      state.inDistribution = val
    },
    setInCourt(state, val) {
      state.inCourt = val
    },
  },

  getters: {
    currentCaseID(state) {
      return state.currentCase.id
    },

    // judge (state) {
    //   return state.judge
    // }
  },

  actions: {

  },

  modules: {
    courtCase,
    judgeReestr,
    judge,
    event,
    fileStore,
    letter,
    list,
    advocat,
    specialist,
    appreestr,
    category,
    users,
    distribution,
    organization,
    menu,
    me,
    page,
    knowledgeBase,
    court,
    gsu,
    expert
  },
})
